import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {COMPETITIONS_SLIDER_WIDGET} from "../competition-slider-widget.consts"
import {CompetitionsSliderWidgetController} from "../competitions-slider-widget.controller";
import {CompetitionsSliderWidgetState} from "../models/competitions-slider-widget.state";

export class CompetitionsSliderWidgetCompetitionChangeHandler extends ActionHandler {
  controller: CompetitionsSliderWidgetController;
  state: CompetitionsSliderWidgetState;
  type = COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.competitionChange;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.state.selectedCompetitionId = params.id;

    this.controller.action(COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.fetchGames);
  }
}
